import { render, staticRenderFns } from "./SkeletonForm.vue?vue&type=template&id=a87d2004&"
import script from "./SkeletonForm.vue?vue&type=script&lang=js&"
export * from "./SkeletonForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports